import React from "react";
import { BRANDS } from "@/data/business";

export default function Brands() {
  const track = [...BRANDS, ...BRANDS];
  return (
    <section id="brands" className="border-y border-slate-200 bg-slate-50 py-14 md:py-16" data-testid="brands-section">
      <div className="container-b">
        <div className="mb-8 flex flex-col items-start gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-blue-700">Authorised & Trusted</div>
            <h2 className="font-heading mt-2 text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
              Brands available in-store
            </h2>
          </div>
          <p className="max-w-md text-sm text-slate-500">
            Genuine products with manufacturer warranty — bought directly from authorised distributors.
          </p>
        </div>
      </div>
      <div className="marquee-mask">
        <div className="marquee-track" data-testid="brands-marquee">
          {track.map((b, i) => (
            <div
              key={`${b}-${i}`}
              className="font-heading text-2xl font-bold uppercase tracking-[0.18em] text-slate-400 sm:text-3xl"
              data-testid={`brand-item-${i}`}
            >
              {b}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
